
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"
import _ from "lodash"

import { CaseDetails, CaseField } from "@/types"

import { formatDateMixin } from "@/mixins/formatDateMixin"

import { TimeSpentAsValue, TimeSpentTotal, TimeSpentEntry } from "@/types/timeSpentAsValue"
import moment from "moment"
import { caseColumns } from "@/types/caseColumns"
const caseStore = namespace("cases")

@Component({
})
export default class TimeSpentDisplay extends Vue {
	@Prop()
	public caseField!: CaseField

	@Prop()
	public timeSpentAsValue!: TimeSpentAsValue;

	@Prop()
	public currentCase!: CaseDetails;

	public get trackingFieldId (): string {
		const extensions = this.caseField.field.extensions ? this.caseField.field.extensions : (this.caseField.field as any).fieldExtensions
		if (!extensions) {
			throw Error("No field extension")
		}
		return extensions.trackingFieldId
	}

	public get trackingCaseFieldName (): string {
		// if a user defined field
		if (this.currentCase.fields[this.trackingFieldId]) {
			return this.currentCase.fields[this.trackingFieldId].field.title
		}

		// else a built in/global field
		const builtInField = caseColumns.find(c => c.key === this.trackingFieldId)
		if (builtInField) {
			return builtInField.label
		}

		return "Error: Could not find tracking field"
	}

	public get lastValueSet (): string {
		const lastValue = _.chain(this.timeSpentAsValue.entries)
			.orderBy("started")
			.last()
			.value()
			.fieldValue

		return lastValue || "No Value Set"
	}
}
